import * as React from 'react'

export const EditBoard = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.5 4H4.222A1.222 1.222 0 0 0 3 5.222v8.556A1.222 1.222 0 0 0 4.222 15h8.556A1.222 1.222 0 0 0 14 13.778V9.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.948 3.352a1.201 1.201 0 1 1 1.7 1.7l-5.382 5.382L7 11l.567-2.266 5.381-5.382Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
